// extracted by mini-css-extract-plugin
export var card = "_3x-0";
export var content = "_3x-1";
export var contentLoading = "_3x-2";